import styled from '@emotion/styled';
import { TextLabel } from 'ds/components/typography';

export const Root = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1.5, 2),
  gap: theme.spacing(4),
  backgroundColor: theme.colors.neutrals.grey1,
  color: theme.colors.neutrals.white,
}));

export const Btn = styled(TextLabel)(({ theme }) => ({
  padding: theme.spacing(1.25, 2),
  cursor: 'pointer',
  borderRadius: theme.borderRadius.smallestSideRound,
  border: `1px solid ${theme.colors.neutrals.white}`,
}));
